import { StyleSheet, Text, View } from 'react-native'

// styles
import { globalStyles } from '../../../static/styles/global'

// compoents
import ModalPopup from './ModalPopup'
import CustomButton from '../button/Button'

interface modalAlertProps {
  title: string
  message: string
  visible: boolean
  setVisible?: any
}

const ModalAlert = ({
  title,
  message,
  visible,
  setVisible
}: modalAlertProps): JSX.Element => {
  return (
    <ModalPopup visible={visible}>
      <View
        style={{ paddingTop: 30, paddingBottom: 30, paddingHorizontal: 20 }}
      >
        <View style={[globalStyles.mb5]}>
          <Text
            style={[
              globalStyles.text,
              globalStyles.fs16,
              globalStyles.fwBold,
              globalStyles.mb1,
              globalStyles.textCenter,
              globalStyles.mb3,
              globalStyles.textUppercase
            ]}
          >
            {title}
          </Text>
          <Text style={[globalStyles.text, globalStyles.textCenter]}>
            {message}
          </Text>
        </View>
        <View style={[globalStyles.hDirection, globalStyles.alignSelfCenter]}>
          <View style={[{ width: 100 }]}>
            <CustomButton
              text={'OK'}
              onPress={() => {
                setVisible(false)
              }}
              color={'danger'}
            />
          </View>
        </View>
      </View>
    </ModalPopup>
  )
}

export default ModalAlert
